let initData = () => {
  return {
    portId: '',
    blNoPrimary: '',
    vessel: '',
    voyage: '',
    portDistrict: '',
    businessNo: '',
    siteConcatlist: [{
      doorAreaId: '',
      siteDoorPointAddress: '',
      siteDoorName: '',
      contactPerson: '',
      contactPhone: ''
    }],
    orderContainers: [],
    isQuarantined: 'false',
    dispatchRequirement: "",
    boundType: "IB",
    electronicBl: [],
    quarantineUrls: [],
    inspection:{
      type:0,
      requirement:null
  }
  }
}
export default {
  namespaced: true,
  state: {
    submitData: initData(),
    selfMakeOrders: [],
    containerTip: false
  },
  mutations: {
    setSubmitData(state, newVal) {
      console.log(newVal);
      if (newVal.orderContainers && newVal.orderContainers.length != 0) {
        newVal.orderContainers.forEach((e, idx) => {
          e.index = idx;
        });
      }
      return (state.submitData = Object.assign(state.submitData, newVal));
    },
    initSubmitData(state, newVal) {
      return (state.submitData = initData())
    },
    setSelfMakeOrders(state,newVal) {
      return (state.selfMakeOrders = newVal)
    },
    setContainerTip(state,newVal) {
      return (state.containerTip = newVal)
    }
  },
  actions: {

  }
};



// WEBPACK FOOTER //
// ./src/views/create-detail-order/store.js